import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconFullCurveDown = deprecatedComponent({
    displayName: 'IconFullCurveDown',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("g", {
            clipPath: "url(#clip0_3072_85517)"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M2.46816 5.82444C2.3712 5.56588 2.083 5.43488 1.82444 5.53184C1.56588 5.6288 1.43488 5.917 1.53184 6.17556L2.46816 5.82444ZM14.4682 6.17556C14.5651 5.917 14.4341 5.6288 14.1756 5.53184C13.917 5.43488 13.6288 5.56588 13.5318 5.82444L14.4682 6.17556ZM1.53184 6.17556C3.77306 12.1522 12.2269 12.1522 14.4682 6.17556L13.5318 5.82444C11.6151 10.9359 4.38495 10.9359 2.46816 5.82444L1.53184 6.17556Z",
            fill: "black"
        })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
            id: "clip0_3072_85517"
        }, /*#__PURE__*/ React.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white"
        })))),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconFullCurveDown };
